import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

const ui = {
  namespaced: true,
  state: () => ({
    dateRange: {
      start: '',
      end: '',
    },
    channel: '',
    tabName: '',
    groupList: [],
  }),
  actions,
  getters,
  mutations,
};

export default ui;
